import flatten from 'lodash/flatten'
import get from 'lodash/get'
import set from 'lodash/set'
import ButtonGroup from '@pc/components/Works/Panel/shared/Button/ButtonGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import EmphasisHeading from '@pc/components/Works/Panel/shared/Heading/EmphasisHeading'
import type { SearchParamsAttributes, ConditionReducer, EtcParams, EtcCheckboxOptions } from '@pc/components/Works/Panel/types'
import { buildDynamicSearchApiUrl } from '@pc/components/Works/Panel/utils/workSearchApi'
import BaseSelectPanel from './BaseSelectPanel'
import CheckBoxEtcInputSet from './EtcSelectPanel/CheckBoxEtcInputSet'
import EtcSelectPanelUpdateButton from './EtcSelectPanel/UpdateButton'

interface PropsType {
  params: SearchParamsAttributes
  etcParams: EtcParams
  conditionReducer: ConditionReducer
  changeEtcParams: (newEtcParams: EtcParams) => void
}

interface EtcConditions {
  brand_ids?: EtcCheckboxOptions[]
}

const EtcSelectPanel = (props: PropsType) => {
  const { params, conditionReducer, etcParams, changeEtcParams } = props
  const etcCheckboxOptions = conditionReducer.attributes.etc_checkbox_options.filter((option) => !(option.sp_only as boolean))
  const etcConditions: EtcConditions = etcCheckboxOptions.reduce((conditions, option) => {
    const prevData: EtcCheckboxOptions[] = get(conditions, option.key, [])
    return set(conditions, option.key, prevData.concat(option))
  }, {})

  const toggleCheckbox = (e: { target: HTMLInputElement }) => {
    const target = e.target
    const conditionKey = target.name
    const conditionValue = target.value

    const newEtcParams = Object.assign({}, etcParams)

    if (target.checked) {
      newEtcParams[conditionKey] = etcParams[conditionKey].concat(conditionValue)
    } else {
      newEtcParams[conditionKey] = etcParams[conditionKey].filter((etcParam) => etcParam !== conditionValue)
    }
    changeEtcParams(newEtcParams)
  }

  const renderEtcCheckboxes = () => {
    return flatten(Object.values(etcConditions)).map((etcCondition) => {
      const etcKey = `${etcCondition.key}-${etcCondition.value}`
      const currentParams: string[] = etcParams[etcCondition.key] ?? []
      return (
        <CheckBoxEtcInputSet key={etcKey}>
          <CheckBoxInput
            type="checkbox"
            id={etcKey}
            name={etcCondition.key}
            value={etcCondition.value}
            onChange={toggleCheckbox}
            checked={currentParams.includes(String(etcCondition.value))}
          />
          <CheckBoxLabel htmlFor={etcKey}>{etcCondition.label}</CheckBoxLabel>
        </CheckBoxEtcInputSet>
      )
    })
  }

  return (
    <BaseSelectPanel>
      <EmphasisHeading>その他条件</EmphasisHeading>
      <ul>{renderEtcCheckboxes()}</ul>
      <ButtonGroup>
        <EtcSelectPanelUpdateButton url={buildDynamicSearchApiUrl({ ...params, ...etcParams })} />
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default EtcSelectPanel
